import React from 'react';
import DaumPostcode from 'react-daum-postcode';

// 닫기 버튼 스타일 (헤더 내부용)
const closeButtonStyle = {
    background: 'transparent',
    border: 'none',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    padding: '0 12px',
    fontFamily: 'Pretendard, sans-serif',
};

// 모달 헤더 타이틀 스타일
const headerTitleStyle = {
    color: '#FFFFFF',
    fontSize: '18px',
    fontWeight: '700',
    fontFamily: 'Pretendard, sans-serif',
};

/**
 * @param {object} props
 * @param {boolean} props.isOpen - 모달이 열려있는지 여부
 * @param {() => void} props.onClose - 모달 닫기 함수
 * @param {(data: object) => void} props.onComplete - 주소 선택 완료 시 콜백
 * @param {number} props.viewportHeight - 동적 뷰포트 높이
 */
function PostcodeModal({ isOpen, onClose, onComplete, viewportHeight }) {
    if (!isOpen) return null;

    // 모달 래퍼 스타일: 앱의 메인 컨텐츠 영역처럼 보이도록 설정
    const modalWrapperStyle = {
        position: 'fixed',
        top: 0,
        left: '50%', // 가로 중앙 정렬
        transform: 'translateX(-50%)', // 가로 중앙 정렬
        width: '101%',
        maxWidth: '450px', // 앱의 최대 너비에 맞춤
        // 전달받은 뷰포트 높이를 사용하거나 100dvh 사용
        height: viewportHeight ? `${viewportHeight}px` : '100dvh',
        backgroundColor: '#0D042D', // 앱 배경색과 동일하게 설정
        zIndex: 2000, // 최상위 레벨
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '60px',
    };

    // 모달 내부 헤더 스타일 (TopNavigator와 유사한 느낌)
    const modalHeaderStyle = {
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 16px',
        borderBottom: '1px solid #1B1931', // 구분선 추가
        backgroundColor: '#0D042D',
        flexShrink: 0,
    };

    // 컨텐츠 영역 (주소 검색창)
    const modalContentStyle = {
        flex: 1, // 남은 공간 모두 차지
        width: '100%',
        backgroundColor: '#0D042D',
        position: 'relative',
    };

    // 사용자 정의 테마 객체 (앱 컬러톤에 맞춤)
    const themeObj = {
        bgColor: "#0D042D", // 바탕 배경색
        searchBgColor: "#1B1931", // 검색창 배경색
        contentBgColor: "#0D042D", // 본문 배경색
        pageBgColor: "#0D042D", // 페이지 배경색
        textColor: "#FFFFFF", // 기본 글자색
        queryTextColor: "#FFFFFF", // 검색창 글자색
        postcodeTextColor: "#8052FF", // 우편번호 글자색 (포인트 컬러)
        emphTextColor: "#0231FB", // 강조 글자색
        outlineColor: "#3A394A" // 테두리 색상
    };

    // 상단 상태바 안전 영역 (iOS 대응)
    const statusBarStyles = {
        height: 'env(safe-area-inset-top, 0px)',
        flexShrink: 0,
        backgroundColor: '#0D042D',
    };

    const handleComplete = (data) => {
        onComplete(data);
        onClose();
    };

    return (
        <div style={modalWrapperStyle}>
            {/* 상태바 영역 */}
            <div className="statusBar" style={statusBarStyles}></div>

            {/* [추가] 모달 헤더 (타이틀 + 닫기 버튼) */}
            <div style={modalHeaderStyle}>
                <span style={headerTitleStyle}>주소 검색</span>
                <button style={closeButtonStyle} onClick={onClose}>
                    닫기
                </button>
            </div>

            {/* 주소 검색 컴포넌트 */}
            <div style={modalContentStyle}>
                <DaumPostcode
                    onComplete={handleComplete}
                    theme={themeObj}
                    style={{ width: '100%', height: '100%' }} // 부모 크기에 꽉 차게
                    autoClose={false}
                />
            </div>
        </div>
    );
}

export default PostcodeModal;